<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXCMNotificationMessageCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering></template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.excmnotificationmessage.list.noNotifications') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.excmnotificationmessage.form.title') }}</th>
            <th>{{ $t('views.excmcyclictask.form.caseType') }}</th>
            <th>{{ $t('views.excmcyclictask.form.taskType') }}</th>
            <th style="width: 5%"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ item.title }}</td>
            <td v-if="item.caseType">
              <router-link v-if="ableToViewCaseType"
                           :to="{name: 'EXCMCaseTypeList', params:{id: item.caseType['@id']}}">
                {{ item.caseType.title }}
              </router-link>
              <span v-else>{{ item.caseType.title }}</span>
            </td>
            <td v-else></td>
            <td v-if="item.taskType">
              <router-link v-if="ableToViewTaskType"
                           :to="{name: 'EXCMTaskTypeList', params:{id: item.taskType['@id']}}">
                {{ item.taskType.title }}
              </router-link>
              <span v-else>{{ item.taskType.title }}</span>
            </td>
            <td v-else></td>
            <td>
              <div class="btn-group">
                <router-link
                  tag="button"
                  class="btn btn-link fa fa-search fa-lg"
                  :to="{ name: 'EXCMNotificationMessageShow', params: { id: item['@id'] }}"
                ></router-link>
                <router-link
                  tag="button"
                  class="btn btn-link fa fa-edit fa-lg"
                  :to="{ name: 'EXCMNotificationMessageUpdate', params: { id: item['@id'] }}"
                ></router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination :view="view" @getPage="getPage($event)"></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'List',
  components: {
    BaseTableWrapper,
    Pagination,
    Loader
  },

  computed: {
    ableToViewCaseType () {
      return checkPermission('configuration', 'EXCMCaseTypeShow')
    },
    ableToViewTaskType () {
      return checkPermission('configuration', 'EXCMTaskTypeShow')
    },
    ...mapGetters({
      error: 'excmnotificationmessage/list/error',
      items: 'excmnotificationmessage/list/items',
      isLoading: 'excmnotificationmessage/list/isLoading',
      view: 'excmnotificationmessage/list/view'
    })
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMNotificationMessageList')
  },
  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmnotificationmessage/list/getItems'
  })
}
</script>

<style scoped>

</style>
